import {ReactNode} from 'react'
import {Link} from 'react-router-dom'
import {ArrowRight} from './PhosphorIcons'

type FeatureCardProps = {
  to: string
  title: string
  description: string
  icon: ReactNode
  tone?: 'primary' | 'neutral' | 'emerald'
}

const FeatureCard = ({
  to,
  title,
  description,
  icon,
  tone = 'neutral',
}: FeatureCardProps) => (
  <Link className={`feature-card feature-card--${tone}`} to={to}>
    <span className='feature-card__icon'>{icon}</span>
    <span className='feature-card__content'>
      <strong>{title}</strong>
      <span>{description}</span>
    </span>
    <ArrowRight aria-hidden='true' className='feature-card__arrow' size={18} weight='bold' />
  </Link>
)

export {FeatureCard}
